module.exports = __webpack_public_path__ + "static/media/icon_lower.61e3bdfd.svg";